
var app = new function(){
  this.modules = {};
  this.settings = {
    easing: 'easeOutQuart',
    easingIn: 'easeInQuart',
    easingOut: 'easeOutQuart',
    easingInOut: 'easeInOutQuart',
    easingSpring: [500, 30],
    duration: 800
  };
  this.vars = {
    isTouchDevice: false,
    smallScreenState: false,
    mediumScreenState: false,
    biggerScreenState: false,
    largeScreenState: false,
    lteIE9: false
  };
  this.names = {
    activeClass: 'is-active'
  };

  this.init = function(){
    var context = this;
    this.detectIE();
    this.detectTouchDevice();
    app.modules.detectScreenSize.detectSize();

    $.each(this.modules, function(index, element){
      if(typeof element.init === 'function')
        element.init();
    });

    this.parse($('body'));
  };

  this.stateChange = function($context){
    $.each(this.modules, function(index, element){
      if(typeof element.stateChange === 'function')
        element.stateChange($context);
    });
  };

  this.parse = function($context){
    $.each(this.modules, function(index, element){
      if(typeof element.parse === 'function')
        element.parse($context);
    });
  };

  this.detectIE = function(){
    var ieTest = $('#ie-test');
    if(ieTest.css('display') == 'inline'){
      this.vars.lteIE9 = true;
    }
  };

  this.detectTouchDevice = function(){
    if (Modernizr.touch) {
      app.vars.isTouchDevice = true;
    }
  };

};

$.extend($.lazyLoadXT, {
  edgeY: 300
});


$(function(){
  app.init();
});


// toggleElement.js
// Open and close elements
// 04.2015 by Szczepan Król
// LOOP Agentur
//
// Basic HTML syntax
// <div class="js-toggle-btn" data-toggle-target="#custom-element-name">Button</div>
// <div id="custom-element-name">Content</div>
//
// Accepted options (added to '.js-toggle-btn' element):
// data-toggle-target="" | <[item identifier]> | Element to open / close (required)
// data-toggle-animation="" | <'slide' (default), 'flyIn'> | Way that target element appears
// data-toggle-autoclose="" | <'false' (default), 'true'> | Close element when clicking outside of it
// data-toggle-animate-items="" | <[item identifier]> | Elements inside a target element to animate
// data-toggle-animate-dir="" | <'left' (default), 'right'> | Direction of child item animation specified above
// data-toggle-scroll="" | <'this' (clicked button), 'anchor' (closest '.js-toggle-anchor' element), [item identifier]> | Scroll to specified element
// data-toggle-position-left="" | <'false' (default), 'true'> | Position target element horizontaly to the button
// data-toggle-close-siblings="" | <'true' (default), 'false'> | Close sibling toogles
//
// Additionaly:
// When "Autoclose" option turned on you may prevent element toggling after clicking on certain element by giving them class 'js-toggle-prevent'

// Dependencies
// velocity.js

function toggleElement() {}

toggleElement.prototype = {

  settings:{
    animateItemsDistance: '32' //pixels
  },

  elements:{
    btn: undefined
  },

  classes:{
    btn: 'js-toggle-btn',
    target: 'js-toggle-target',
    prevent: 'js-toggle-prevent',
    anchor: 'js-toggle-anchor',
    isActive: 'is-active'
  },

  init: function(){
  },

  parse: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.btn = $('.' + this.classes.btn);
  },

  addListener: function(){
    // Button click handler
    this.elements.btn.on('click', {self:this}, function(e){
      var self = e.data.self;
      self.toggleAction($(this), e);
    });

    // Click outside the element handler
    $(document).on('click', {self:this}, function(event) {
      var self = event.data.self;
      if (!$(event.target).closest('.' + self.classes.btn + '.' + self.classes.isActive).length && !$(event.target).closest('.' + self.classes.prevent).length) {
        var element = $('.' + self.classes.btn + '.' + self.classes.isActive + '[data-toggle-autoclose="true"]');
        element.each(function(){
          self.closeToggle($(this));
        });
      }
    });
  },

  toggleAction: function(element, event){

    // Default settings
    var positionLeft = false;
    var animateItems = false;
    var animation = 'slide';
    var delay = 0;
    var closeSiblings = false;
    var onlySmall = false;

    // Get data
    var elementData = element.data();
    var targetName = elementData['toggleTarget'];
    var positionLeftData = elementData['togglePositionLeft'];
    var animateItemsData = elementData['toggleAnimateItems'];
    var animateDirData = elementData['toggleAnimateDir'];
    var scrollData = elementData['toggleScroll'];
    var animationData = elementData['toggleAnimation'];
    var scrollDelayData = elementData['toggleScrollDelay'];
    var closeSiblingsData = elementData['toggleCloseSiblings'];
    var onlySmallData = elementData['toggleOnlySmall'];

    // Alter settings
    if(positionLeftData != '' && positionLeftData != undefined){
      positionLeft = true;
    }
    if(animateItemsData != '' && animateItemsData != undefined){
      animateItems = true;
    }
    if(animationData != '' && animationData != undefined){
      animation = animationData;
    }
    if(scrollDelayData == true){
      delay = app.settings.duration;
    }
    if(closeSiblingsData == true){
      closeSiblings = true;
    }
    if(onlySmallData == true){
      onlySmall = true;
    }

    if(onlySmall && !app.vars.smallScreenState){
      return;
    } else {
      event.preventDefault();
    }

    // Close sibling toggles
    if(closeSiblings){
      var activeSiblings = element.siblings('.' + this.classes.isActive);
      this.closeToggle(activeSiblings);
    }

    // Get target element
    var target = $('body').find(targetName);

    // Perform show/close action
    if(target.hasClass(this.classes.isActive)){
      this.closeToggle(element);
    } else {

      // Position element (if option selected)
      if(positionLeft){
        var elLeft = element.position().left;
        target.css('left', elLeft);
      }

      // Animate items (if option selected)
      if(animateItems){
        this.animateInItems(target, animateItemsData, animateDirData);
      }

      // Add active classes
      element.addClass(this.classes.isActive);
      target.addClass(this.classes.isActive);

      // Animate element (default 'slide')
      if(animation == 'slide'){
        target.velocity('slideDown',{
          duration: app.settings.duration/2,
          easing: app.settings.easing,
          complete: function(){
            $('body').trigger('toggleOpen', [targetName]);
          }
        });
      } else if (animation == 'flyIn'){
        $.Velocity.hook(target, "scale", "3");
        target.velocity({
          scale: 1,
          opacity: 1
        },{
          duration: app.settings.duration/2,
          easing: app.settings.easing,
          display: 'block'
        });
      }

      // Scroll to element (if option selected)
      if(scrollData != ''){
        var scrollElement;
        if(scrollData == 'this'){
          scrollElement = element;
        } else if(scrollData == 'anchor'){
          scrollElement = element.closest('.' + this.classes.anchor);
        } else {
          scrollElement = $(scrollData);
        }
        scrollElement.velocity('scroll',{
          duration: app.settings.duration/2,
          easing: app.settings.easing,
          delay: delay
        });
      }
    }
  },

  closeToggle: function(element){

    // Get elements
    var targetName = element.data('toggleTarget');
    var target = $(targetName);
    var sameTargetButtons = $('.' + this.classes.btn + '[data-toggle-target="' + targetName + '"]');
    var animation = 'slide';

    // Trigger 'toggleClose' event with target name as data
    $('body').trigger('toggleClose', [targetName]);

    // Get animation style
    var animationData = element.data('toggleAnimation');
    if(animationData != '' && animationData != undefined){
      animation = animationData;
    }

    // Remove active classes
    element.removeClass(this.classes.isActive);
    sameTargetButtons.removeClass(this.classes.isActive);
    target.removeClass(this.classes.isActive);

    // Animate element
    if(animation == 'slide'){
      target.velocity('slideUp',{
        duration: app.settings.duration/2,
        easing: app.settings.easing
      });
    } else if (animation == 'flyIn'){
      target.velocity({
        scale: 2,
        opacity: 0
      },{
        duration: app.settings.duration/2,
        easing: app.settings.easing,
        display: 'none'
      });
    }
  },

  toggleElementWithName: function(name){
    var btn = $('.' + this.classes.btn + '[data-toggle-target="' + name + '"]');
    this.toggleAction(btn);
  },

  animateInItems: function(element, item, dir){

    // Get items
    var animItem = element.find(item);
    var startLeft = -this.settings.animateItemsDistance;

    // Get direction (default 'left')
    if(dir == 'right'){
      startLeft =  this.settings.animateItemsDistance;
    }

    // Set start positions
    animItem.css({
      'position': 'relative',
      'left': startLeft + 'px',
      'opacity': '0'
    });

    // Animate each item
    animItem.each(function(index){
      $(this).delay(index*app.settings.duration/14).velocity({
        left: 0,
        opacity: 1
      },
        {
          duration: app.settings.duration/2,
          easing: app.settings.easing
        });
    });
  }

};

app.modules.toggleElement = new toggleElement;



// aliveLabel.js
// After focusing on field label goes up and becomes smaller
// 04.2015 by Szczepan Król
// LOOP Agentur

// Basic HTML syntax:
// <div class="form__row">
//   <label class="form__label  form__label--alive  js-alive-label" for="name">Name</label>
//   <input class="form__field  form__field--text  js-alive-field" type="text" name="name" id="name">
// </div>

// Basic Sass syntax:
// .form{
//   &__row{
//     position: relative;
//   }
//   &__label{
//     display: inline-block;
//      &--alive{
//       transition: all $anim-duration;
//       position: absolute;
//       top: 22px;
//       &.is-active{
//         top: -2px;
//         font-size: $font-size-small;
//       }
//     }
//   }
// }

// Dependencies
// velocity.js


function aliveLabel() {}

aliveLabel.prototype = {

  elements: {
    field: undefined
  },

  classes:{
    label: 'js-alive-label',
    field: 'js-alive-field',
    isActive: 'is-active'
  },

  init: function(){
  },

  parse: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.field = $('.' + this.classes.field);
  },

  addListener: function(){
    $('body').on('focusin', '.' + this.classes.field, {self: this}, function(e){
      var self = e.data.self;
      self.focusInHandler($(this));
    });

    $('body').on('focusout', '.' + this.classes.field, {self: this}, function(e){
      var self = e.data.self;
      self.focusOutHandler($(this));
    });
  },

  focusInHandler: function(element){
    var label = element.prev('.' + this.classes.label);
    if(!label.hasClass(this.classes.isActive)){
      label.addClass(this.classes.isActive);
      $('body').trigger('formfocusedin', element);
    }
  },

  focusOutHandler: function(element){
    var label = element.prev('.' + this.classes.label);
    if(element.val().length == 0){
      label.removeClass(this.classes.isActive);
    }
  }


};

app.modules.aliveLabel = new aliveLabel;



function detectScreenSize() {}

detectScreenSize.prototype = {

  settings:{
    smallScreenBreakpoint: '641',
    mediumScreenBreakpoint: '1024',
    largeScreenBreakpoint: '1200'
  },

  vars:{
    triggerCount: false
  },

  init: function(){
  },

  parse: function(){
    this.addListener();
  },

  addListener: function(){
    $(window).on('resize', {self: this}, function(e){
      var self = e.data.self;
      self.detectSizeAfterResize();
    });

    $('body').on('screenStateChange', {self:this}, function(){
      app.stateChange();
    });
  },

  detectSize: function(callback){
      this.checkForChange(this.settings.smallScreenBreakpoint, "smallScreenState", '<');
      this.checkForChange(this.settings.mediumScreenBreakpoint, "mediumScreenState", '<');
      this.checkForChange(this.settings.mediumScreenBreakpoint, 'biggerScreenState', '>');
      this.checkForChange(this.settings.largeScreenBreakpoint, 'largeScreenState', '>');

      if(this.vars.triggerCount == true){
        if(callback == true){
          this.triggerEvent();
        }
      }
      this.vars.triggerCount = false;
  },

  detectSizeAfterResize: function(){
    var self = this;
    // waitForFinalEvent(function(){
      self.detectSize(true);
     // }, 250, "resizing");
  },

  checkForChange: function(breakpoint, state, operation){
    var windowWidth = window.innerWidth;
    if(operation == '<'){
      if(windowWidth < breakpoint){
        if(app.vars[state] == false) {
          app.vars[state] = true;
          this.vars.triggerCount = true;
        }
      } else {
        if(app.vars[state] == true) {
          app.vars[state] = false;
          this.vars.triggerCount = true;
        }
      }
    }
    else if (operation == '>'){
      if(windowWidth >= breakpoint){
        if(app.vars[state] == false) {
          app.vars[state] = true;
          this.vars.triggerCount = true;
        }
      } else {
        if(app.vars[state] == true) {
          app.vars[state] = false;
          this.vars.triggerCount = true;
        }
      }
    }

  },

  triggerEvent: function(){
    $('body').trigger('screenStateChange');
  }

};

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

app.modules.detectScreenSize = new detectScreenSize;

function initPlugins() {}

initPlugins.prototype = {

  classes:{
    aboutCounter: '.js-about-counter',
    autosizeTextarea: '.js-autosize',
    matchHeight: '.js-match-height',
    matchHeight2: '.js-match-height-2'
  },

  init: function(){
    this.initFastClick();

  },

  parse: function(){
    this.addListener();
    this.initSkrollr();
    this.initMatchHeight();
  },

  addListener: function(){
    $(document).on('slideoutChanged', {self: this}, function(event, slideout, currentSlide){
      var self = event.data.self;
      var slideoutName = slideout.data('slideoutName');
      if(slideoutName == 'about' && currentSlide == '2'){
        self.initCounters();
      }
    });

    $('body').one('click', this.classes.autosizeTextarea, {self: this}, this.initAutosize);
  },

  initFastClick: function(){
    FastClick.attach(document.body);
  },

  initCounters: function(){
    $(this.classes.aboutCounter).countTo({
      speed: 800,
      refreshInterval: 20
    });
  },

  initStickyKit: function(element){
    // $(element).stick_in_parent();
  },

  initAutosize: function(event){
    var self = event.data.self;
    autosize($(self.classes.autosizeTextarea));
  },

  initSkrollr: function(){
    if(!app.vars.isTouchDevice){
      var s = skrollr.init({
        forceHeight: false
      });
    }
  },

  initMatchHeight: function(){
    $(this.classes.matchHeight).matchHeight({
      byRow: true
    });
    $(this.classes.matchHeight2).matchHeight({
      byRow: true
    });
  },

};

app.modules.initPlugins = new initPlugins;

// slideout.js
// Tab system
// 04.2015 by Szczepan Król
// LOOP Agentur

// Basic HTML syntax
// <div class="js-slideout" data-slideout-hover="true">
//   <div class="js-slideout-control" data-slideout="1">First Tab Button</div>
//   <div class="js-slideout-control" data-slideout="2">Second Tab Button</div>

//   <div class="js-slideout-container">
//     <div class="js-slideout-content" data-slideout="1">First Tab Content</div>
//     <div class="js-slideout-content" data-slideout="2">Second Tab Content</div>
//   </div>
// </div>


// Accepted options (added to '.js-slideout' element):
// data-slideout-hover="" | <'false' (default), 'true'> | Should action be triggered also by hovering over the button
// data-slideout-direction="vertical"
// data-slideout-accordion="true"
// data-slideout-nav-autoheight="true"

// Dependencies
// velocity.js


function slideout() {}

slideout.prototype = {

  settings:{
    distance: '50px'
  },

  elements:{
    slideout: undefined,
    control: undefined,
    content: undefined,
    container: undefined,
    nav: undefined,
    arrow: undefined
  },

  classes:{
    slideout: 'js-slideout',
    content: 'js-slideout-content',
    control: 'js-slideout-control',
    container: 'js-slideout-container',
    nav: 'js-slideout-nav',
    arrow: 'js-slideout-arrow',
    isActive: 'is-active',
    isAccordion: 'is-accordion'
  },

  vars:{
    startNo: 1,
    itemCount: 0
  },

  init: function(){
  },

  parse: function(){
    this.defineElements();
    this.initialSetup();
    this.addListener();
  },

  defineElements: function(){
    this.elements.slideout = $('.' + this.classes.slideout);
    this.elements.control = $('.' + this.classes.control);
    this.elements.content = $('.' + this.classes.content);
    this.elements.container = $('.' + this.classes.container);
    this.elements.nav = $('.' + this.classes.nav);
    this.elements.arrow = $('.' + this.classes.arrow);
  },

  stateChange: function(){
    var self = this;
    this.initialSetup(true);
    this.updateActiveSlideoutSize();
  },

  addListener: function(){

    $('body').on('mouseenter  touchstart', '.' + this.classes.control, {self: this}, function(e){
      var self = e.data.self;
      var element = $(this);
      var slideout = $(this).closest('.' + self.classes.slideout);
      var elementNo = element.data('slideout');
      var direction = self.getDirection(slideout);
      if(slideout.data('slideoutHover') == true){
        self.showSlideout(elementNo, slideout, direction);
      }
    });

    $('body').on('click', '.' + this.classes.control, {self: this}, function(e){
      var self = e.data.self;
      var element = $(this);
      var elementNo = element.data('slideout');
      var slideout = $(this).closest('.' + self.classes.slideout);
      var direction = self.getDirection(slideout);
      if(slideout.data('slideoutHover') != true){
        self.showSlideout(elementNo, slideout, direction);
      }
    });

    this.elements.slideout.on('swipeleft', {self: this}, function(e){
      if(!app.vars.isTouchDevice) return false;
      var self = e.data.self;
      var slideout = $(this).closest('.' + self.classes.slideout);
      var itemCount = slideout.find('.' + self.classes.content).length;
      var currentNo = slideout.data('slideoutCurrent');
      var targetNo = parseInt(currentNo) + 1;
      if(targetNo == parseInt(itemCount)+1){
        targetNo = 1;
      }
      // var element = slideout.find('.' + self.classes.control + '[data-slideout="' + targetNo + '"]');
      var direction = self.getDirection(slideout);
      self.showSlideout(targetNo, slideout, direction);
    });

    this.elements.slideout.on('swiperight', {self: this}, function(e){
      if(!app.vars.isTouchDevice) return false;
      var self = e.data.self;
      var slideout = $(this).closest('.' + self.classes.slideout);
      var itemCount = slideout.find('.' + self.classes.content).length;
      var currentNo = slideout.data('slideoutCurrent');
      var targetNo = parseInt(currentNo) - 1;
      if(targetNo == 0){
        targetNo = itemCount;
      }
      // var element = slideout.find('.' + self.classes.control + '[data-slideout="' + targetNo + '"]');
      var direction = self.getDirection(slideout);
      self.showSlideout(targetNo, slideout, direction);
    });

    $('body').on('toggleOpen', {self: this}, function(e, targetName){
      var self = e.data.self;
      if(self.elements.slideout.length){
        var targetEl = $(targetName);
        if (targetEl.hasClass(self.classes.slideout)) {
          var targetContainer = targetEl.find('.' + self.classes.container);
          if(targetContainer.height() == 0){
            var currentContentNo = targetEl.data('slideoutCurrent');
            var currentContent = targetEl.find('.' + self.classes.content + '[data-slideout="' + currentContentNo + '"]');
            var accordionSetting = self.getAccordionSetting(slideout);
            self.setContainerHeight(currentContent, targetEl, accordionSetting);
          }
        };
      }
    });
  },

  initialSetup: function(stateChange){
    if(this.elements.slideout.length){
      var self = this;

      this.elements.slideout.each(function(){
        var startingPosition = self.vars.startNo;
        var dataSlideoutActive = $(this).data('slideoutActive');
        var dataSlideoutScroll = $(this).data('slideoutScroll');
        if(dataSlideoutActive != undefined && dataSlideoutActive != '') {
          startingPosition = dataSlideoutActive;
        }
        if(app.vars.smallScreenState) {
          startingPosition = '-1';
        }

        if(dataSlideoutScroll){
          var thisSlideout = $(this);
          setTimeout(function(){
            thisSlideout.velocity('scroll',{
              duration: app.settings.duration*1,
              easing: app.settings.easingInOut
            });
          }, app.settings.duration/2);
        }

        var content = $(this).find('.' + self.classes.content + '[data-slideout="' + startingPosition + '"]');
        var control = $(this).find('.' + self.classes.control + '[data-slideout="' + startingPosition + '"]');

        var contents = $(this).find('.' + self.classes.content);
        var accordionSetting = self.getAccordionSetting($(this));

        if(!stateChange){
          var itemCount = contents.length;
          $(this).attr('data-slideout-current', startingPosition);
          if(!accordionSetting){
            content.show().addClass(self.classes.isActive);
            control.show().addClass(self.classes.isActive);
          }
        }

        if(accordionSetting){
          self.generateAccordion($(this));
        } else {
          self.removeAccordion($(this));
          self.setContainerHeight(content, $(this), accordionSetting);
          self.positionArrow($(this), control);

          var $slideout = $(this);
          setTimeout(function() {
            self.setContainerHeight(content, $slideout, accordionSetting);
          }, 1000);
          var currentState = $(this).data('slideoutCurrent');
          var currentControl = $(this).find('.' + self.classes.control + '.' + self.classes.isActive);
          var targetControl = $(this).find('.' + self.classes.control + '[data-slideout="' + currentState + '"]')
          currentControl.removeClass(self.classes.isActive);
          targetControl.addClass(self.classes.isActive);
        }

      });
}
},

showSlideout: function(elementNo, slideout, direction){
  // var elementNo = element.data('slideout');
  var currentNo = slideout.attr('data-slideout-current');
  var accordionSetting = this.getAccordionSetting(slideout);
  var element = slideout.find('.' + this.classes.control + '[data-slideout="' + elementNo + '"]');
  if(accordionSetting && app.vars.smallScreenState){
    var element = slideout.find('.' + this.classes.container).find('.' + this.classes.control + '[data-slideout="' + elementNo + '"]');
  } else {
    var element = slideout.find('.' + this.classes.control + '[data-slideout="' + elementNo + '"]');
  }
  if(elementNo != currentNo){
    var currentContent = slideout.find('.' + this.classes.content + '[data-slideout="' + currentNo + '"]');
    var currentControl = slideout.find('.' + this.classes.control + '[data-slideout="' + currentNo + '"]');
    var targetContent = slideout.find('.' + this.classes.content + '[data-slideout="' + elementNo + '"]');

    this.setContainerHeight(targetContent, slideout, accordionSetting);
    this.positionArrow(slideout, element);

    currentContent.removeClass(this.classes.isActive);
    currentControl.removeClass(this.classes.isActive);
    targetContent.addClass(this.classes.isActive);
    element.addClass(this.classes.isActive);

    var delta,
    newCurrentLeft,
    oldTargetLeft;

    if(elementNo > currentNo){
      delta = 'more';
    } else {
      delta = 'less';
    }

    slideout.data('slideout-current', elementNo);
    slideout.attr('data-slideout-current', elementNo);

    if(accordionSetting && app.vars.smallScreenState){

      currentContent.velocity('stop')
      .velocity('slideUp',{
        duration: app.settings.duration/2,
        easing: app.settings.easing,
        display: "none"
      });

      if(elementNo != '-1'){
        targetContent.css(animatedProperty, oldTargetLeft)
        .velocity('stop')
        .velocity('slideDown',{
          duration: app.settings.duration/2,
          easing: app.settings.easingIn,
          display: 'block'
        });

        setTimeout(function(){
          $('html, body').animate({
            scrollTop: element.offset().top
          }, app.settings.duration/2);
        }, app.settings.duration/2);
      }

    } else {

      if(delta == 'more'){
        newCurrentLeft = -(parseInt(this.settings.distance));
        oldTargetLeft = this.settings.distance;
      } else {
        newCurrentLeft = this.settings.distance;
        oldTargetLeft = -(parseInt(this.settings.distance));
      }

      var animatedProperty;
      var currentContentProperties = {
        opacity: 0
      };
      var targetContentProperties = {
        opacity: 1
      };
      if(direction == 'horizontal'){
        currentContentProperties.marginLeft = newCurrentLeft;
        targetContentProperties.marginLeft = 0;
        animatedProperty = 'margin-left';
      } else if (direction == 'vertical') {
        currentContentProperties.marginTop = newCurrentLeft;
        targetContentProperties.marginTop = 0;
        animatedProperty = 'margin-top';
      }

      currentContent.velocity('stop')
      .velocity(currentContentProperties,{
        duration: app.settings.duration/2,
        easing: app.settings.easingOut,
        display: "none"
      });

      targetContent.css(animatedProperty, oldTargetLeft)
      .velocity('stop')
      .velocity(targetContentProperties,{
        duration: app.settings.duration/2,
        easing: app.settings.easingOut,
        delay: app.settings.duration/4,
        display: 'block'
      });
    }

    $(document).trigger('slideoutChanged', [slideout, elementNo]);
  } else {
    if(accordionSetting && app.vars.smallScreenState){
      this.showSlideout('-1', slideout);
    }
  }

},

setContainerHeight: function(targetContent, slideout, accordionState){
  if(!accordionState){
    var containerHeight = 0;
    var container = slideout.find('.' + this.classes.container);
    var contentHeight = targetContent.outerHeight();
    container.velocity('stop')
    .velocity({
      'height': contentHeight
    },{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });

    if(slideout.data('slideoutNavAutoheight')){
      var nav = slideout.find('.' + this.classes.nav);
      nav.velocity('stop')
      .velocity({
        'min-height': contentHeight
      },{
        duration: app.settings.duration/2,
        easing: app.settings.easing
      });
    }
  }
},

setCurrentTabHeight: function(slideout){
  var targetContent = slideout.find('.' + this.classes.content + '.' + this.classes.isActive + ':visible');
  var accordionState = this.getAccordionSetting(slideout);
  this.setContainerHeight(targetContent, slideout, accordionState);
},

updateActiveSlideoutSize: function(){

  var self = this;
  var activeSlideouts = $('.' + this.classes.slideout + ':visible');
  activeSlideouts.each(function(){
    self.setCurrentTabHeight($(this));
  });
},

getDirection: function(slideout){
  var direction = 'horizontal';
  if(slideout.data('slideoutDirection') != undefined && slideout.data('slideoutDirection') != ''){
    direction = slideout.data('slideoutDirection');
  }
  return direction;
},

getAccordionSetting: function(slideout){
  var accordionState = false;
  if(slideout.data('slideoutAccordion') != undefined && slideout.data('slideoutAccordion') != ''){
    if(slideout.data('slideoutAccordion') == true && app.vars.smallScreenState){
      accordionState = true;
    }
  }
  return accordionState;
},

generateAccordion: function(slideout){
  var self = this;
  slideout.addClass(self.classes.isAccordion);
  var container = slideout.find('.' + self.classes.container);
  var nav = slideout.find('.' + self.classes.nav);
  var navItems = nav.find('.' + self.classes.control);

  container.removeAttr('style');
  nav.removeAttr('style');

  navItems.each(function(){
    var currentIndex = $(this).data('slideout');
    var content = slideout.find('.' + self.classes.content + '[data-slideout="' + currentIndex + '"]');
    content.css({
      height: 'auto',
      marginLeft: 0,
      marginTop: 0,
      opacity: 1
    });
    content.before($(this).clone(true));
  });
},

removeAccordion: function(slideout){
  var self = this;
  slideout.removeClass(self.classes.isAccordion);
  var container = slideout.find('.' + self.classes.container);
  var navItems = container.find('.' + self.classes.control);
  navItems.remove();
},

positionArrow: function(slideout, element){
  var arrow = slideout.find('.' + this.classes.arrow);
  if(arrow.length){
    var accordionSetting = this.getAccordionSetting(slideout);
    if(!accordionSetting){
      var elementOffset = element.position().top;
      var elementHeight = element.outerHeight();
      var arrowPosition = elementOffset + elementHeight/2;
      arrow.velocity({
        'top': arrowPosition
      },{
        duration: app.settings.duration/2,
        easing: app.settings.easing,
        complete: function(){
          $(this).css('opacity', 1);
        }
      });
    }
  }
}

};

app.modules.slideout = new slideout;

// svgFallback.js
// Exchange your svgs with pngs on old browsers
// 04.2015 by Szczepan Król
// LOOP Agentur

// Dependencies
// modernizr.js

function svgFallback() {}

svgFallback.prototype = {

  parse: function(){
    this.switchSources();
  },

  switchSources: function(){
    if (!Modernizr.svg) {
      var svgImages =  $("img[src$='.svg']");
      svgImages.each(function(){
        var file = $(this).attr("src").split('.', 1);
        $(this).attr("src", file + '.png');
      });
    }
  }

};

app.modules.svgFallback = new svgFallback;



function login() {}

login.prototype = {

  elements: {
    links: undefined
  },

  classes:{
    links: '.js-login-links',
    form: '.js-login-form'
  },

  init: function(){
  },

  parse: function(){
    this.addListener();
  },

  defineElements: function(){
    this.elements.links = $(this.classes.links);
  },

  addListener: function(){
    $('body').on('formfocusedin', {self: this}, function(event, element){
      var self = event.data.self;
      self.formFocusedInHandler(element);
    });
  },

  formFocusedInHandler: function(element){
    var form = $(element).closest(this.classes.form);
    var links = form.find(this.classes.links);
    links.addClass(app.names.activeClass);
  }

};

app.modules.login = new login;

function search() {}

search.prototype = {

  elements: {
    btn: undefined,
    field: undefined
  },

  classes: {
    btn: '.js-search-button',
    field: '.js-search-field'
  },

  parse: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.btn = $(this.classes.btn);
    this.elements.field = $(this.classes.field);
  },

  addListener: function(){
    this.elements.btn.on('click', {self: this}, this.btnClickHandler);
    $(document).keypress(function(e) {
      if(e.which == 13) {
        this.enterPressHandler;
      }
    });
  },

  btnClickHandler: function(event){
    var self = event.data.self;
    setTimeout(function(){
      self.elements.field.focus();
    }, app.settings.duration);
  },

  enterPressHandler: function(){
    if(this.elements.field.is(':focus')){
      var form = this.elements.field.parent('form');
      form.submit();
    }
  }

};

app.modules.search = new search;

// responsiveImg.js
// Nice hotspots on the images which toggle tooltips on hover
// 04.2015 by Szczepan Król
// LOOP Agentur

// Basic HTML syntax:
// <div class="js-responsive-bg"  data-rsp-bg-small="/assets/web/img/news/news-detail-2.jpg" data-rsp-bg-big="/assets/web/img/news/news-detail-2.jpg"></div>

// Accepted options (added to '.js-delayed-link' element):
// data-rsp-bg-small="" | <[file path]> | Small image
// data-rsp-bg-big="" | <[file path]> | Big image

// Dependencies
// preloader.js - LOOP Plugin


function responsiveImg() {}

responsiveImg.prototype = {

  settings:{
    bigBreakpoint: 768
  },

  elements:{
    bg: $('.js-responsive-bg')
  },

  classes:{
    bg: 'js-responsive-bg',
    isLoaded: 'is-loaded'
  },

  vars:{
    loaderArray: [],
    windowWidth: undefined
  },

  init: function(){
  },

  parse: function(){
    this.vars.windowWidth = $(window).outerWidth();
    this.setBackgrounds();
  },

  stateChange: function(){
    if(this.elements.bg.length){
      this.setBackgrounds();
    }
  },

  setBackgrounds: function(context){
    if(context == undefined || context == ''){
      context = $('body');
    }
    var self = this;
    var elements = context.find('.' + this.classes.bg);
    elements.each(function(){
      self.loadBackground($(this));
    });
  },

  loadBackground: function(element, class){
    var srcSmall, srcBig;
    var self = this;
    srcSmall = element.data('rspBgSmall');
    srcBig = element.data('rspBgBig');

    this.vars.loaderArray.push(element);
    var loaderIndex = $.inArray(element, this.vars.loaderArray);

    app.modules.preloader.showPreloader(element, loaderIndex);

    if(app.vars.smallScreenState){
      element.css('background-image', 'url(' + srcSmall + ')');
    } else {
      element.css('background-image', 'url(' + srcBig + ')');
    }

    element.waitForImages({
      finished: function(event) {
         app.modules.preloader.hidePreloader(element, loaderIndex);
         element.addClass(self.classes.isLoaded);
         $(document).trigger('responsiveImgLoaded', $(this));
      },
      waitForAll: true
    });

  }

};

app.modules.responsiveImg = new responsiveImg;

// preloader.js
// Preloader for your page
// 04.2015 by Szczepan Król
// LOOP Agentur

// Use:
// app.modules.preloader.showPreloader(element, loaderIndex);
// app.modules.preloader.hidePreloader(element, loaderIndex);

// Dependencies
// velocity.js

function preloader() {}

preloader.prototype = {

  settings: {
    preloadTimeout: 0.5 // seconds
  },

  classes: {
    preloader: 'preloader',
    typeFree: 'preloader--free',
    typeInside: 'preloader--inside',
    typeInstead: 'preloader--instead'
  },

  vars: {
    preloadTimeout: [],
    prelInst: 0
  },

  showPreloader: function(element, loaderIndex, position){
    var self = this;
    var preloader, preloaderInstance;
    var timeout = self.settings.preloadTimeout*1000;

    if(element.length){
      if(position == 'inside'){
        preloader = $('<div>').addClass(this.classes.preloader).addClass(this.classes.typeInside).attr('data-preloader', loaderIndex);
        element.prepend(preloader);
        preloaderInstance = element.find('.' + this.classes.preloader + '[data-preloader="' + loaderIndex + '"]');
        timeout = 0;
      } else if( position == 'instead'){
        preloader = $('<div>').addClass(this.classes.preloader).addClass(this.classes.typeInstead).attr('data-preloader', loaderIndex);
        element.html(preloader);
        preloaderInstance = element.find('.' + this.classes.preloader + '[data-preloader="' + loaderIndex + '"]');
        timeout = 0;
      } else{
        var elTop = element.position().top;
        var elLeft = element.position().left;
        preloader = $('<div>').addClass(this.classes.preloader).addClass(this.classes.typeFree).attr('data-preloader', loaderIndex).css({'top': elTop, 'left': elLeft});
        element.after(preloader);
        preloaderInstance = element.next('.' + this.classes.preloader + '[data-preloader="' + loaderIndex + '"]');
      }

      this.vars.preloadTimeout[loaderIndex] = setTimeout(function(){
        preloaderInstance.velocity('fadeIn', {duration: app.settings.duration, display: 'inline-block'});
      }, timeout);
    }
  },

  hidePreloader: function(element, loaderIndex, position){
    var preloaderInstance;
    clearTimeout(this.vars.preloadTimeout[loaderIndex]);
    if(position == 'inside'){
      preloaderInstance = element.find('.' + this.classes.preloader + '[data-preloader="' + loaderIndex + '"]');
    } else {
      preloaderInstance = element.next('.' + this.classes.preloader + '[data-preloader="' + loaderIndex + '"]');
    }
    preloaderInstance.velocity('fadeOut',
    {
      duration: app.settings.duration/14,
      complete: function(){
        $(this).remove();
      }
    });
  }
};


app.modules.preloader = new preloader;

function scrollToNext() {}

scrollToNext.prototype = {

  elements:{
    btn: undefined
  },

  classes:{
    module: '.module',
    btn: '.js-scroll-next-btn'
  },

  parse: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.btn = $(this.classes.btn);
  },

  addListener: function(){
    this.elements.btn.on('click', {self: this}, this.btnClickHandler);
  },

  btnClickHandler: function(event){
    var self = event.data.self;
    var element = $(event.currentTarget);
    var parentModule = element.closest(self.classes.module);
    var nextModule = parentModule.next(self.classes.module);

    nextModule.velocity("scroll", {
      duration: app.settings.duration*1.5,
      easing: app.settings.easingInOut
    });
  }
};

app.modules.scrollToNext = new scrollToNext;

function accordion() {}

accordion.prototype = {

  elements:{
    accordion: undefined,
    title: undefined
  },

  classes:{
    accordion: '.js-accordion',
    title: '.js-accordion-title',
    content: '.js-accordion-content',
    item: '.js-accordion-item'
  },


  init: function(){
  },

  parse: function(){
    this.defineElements();
    this.addListener();
    this.initialSetup();
  },

  defineElements: function(){
    this.elements.title = $(this.classes.title);
    this.elements.accordion = $(this.classes.accordion);
  },

  addListener: function(){
    $('body').on('click', this.classes.title, {self: this}, this.titleClickHandler);
  },

  initialSetup: function(){
    if(this.elements.accordion.length){
      var self = this;
      this.elements.accordion.each(function(){
        var firstItem = $(this).find(self.classes.item).first();
        self.openAccordionItem(firstItem);
      });
    }
  },

  titleClickHandler: function(event){
    var self = event.data.self;
    var title = $(event.currentTarget);
    var item = title.parent(self.classes.item);
    var accordion = title.closest(self.classes.accordion);
    var oldItem = accordion.find(self.classes.item + '.' + app.names.activeClass);
    if(!item.hasClass(app.names.activeClass)){
      self.closeAccordionItem(oldItem);
      self.openAccordionItem(item);
    } else {
      self.closeAccordionItem(item);
    }
  },

  openAccordionItem: function(item){
    var self = this;
    var content = item.find(this.classes.content);
    item.addClass(app.names.activeClass);

    content.slideDown(app.settings.duration/3, function(){
      self.openAccordionSuccess(item);
    });
  },

  closeAccordionItem: function(item){
    var content = item.find(this.classes.content);
    item.removeClass(app.names.activeClass);
    content.slideUp(app.settings.duration/3);
  },

  openAccordionSuccess: function(item){

    // resize slideout if accordion is inside
    var slideout = item.parents('.' + app.modules.slideout.classes.slideout);
    if(slideout.length){
      app.modules.slideout.setCurrentTabHeight(slideout);
    }
  }

};

app.modules.accordion = new accordion;

function clients() {}

clients.prototype = {

  settings:{
    interval: 5, // seconds
    duration: app.settings.duration*1.5
  },

  elements:{
    clients: undefined
  },

  classes:{
    clients: '.js-clients',
    img: '.js-clients-img',
    hiddenImg: '.js-clients-img-hidden'
  },

  init: function(){
  },

  parse: function(){
    this.defineElements();
    this.startAnimation();
  },

  defineElements: function(){
    this.elements.clients = $(this.classes.clients);
  },

  startAnimation: function(){
    var self = this;
    setInterval(function(){
      self.changeLogo();
    }, self.settings.interval*1000);
  },

  changeLogo: function(){
    if(this.elements.clients.length){
      var self = this;
      var imgs = this.elements.clients.find(this.classes.img);
      var randomImg = imgs[Math.floor(Math.random()*imgs.length)];
      randomImg = $(randomImg);
      var hiddenImg = this.elements.clients.find(this.classes.hiddenImg).first();

      var oldSrc = randomImg.attr('src');
      var oldTitle = randomImg.attr('title');
      var newSrc = hiddenImg.attr('src');
      var newTitle = hiddenImg.attr('title');

      hiddenImg.attr('src', oldSrc);
      hiddenImg.attr('title', oldTitle);
      hiddenImg.detach().appendTo(this.elements.clients);

      randomImg.velocity('fadeOut',{
        duration: self.settings.duration,
        easing: app.settings.easingIn,
        complete: function(){
          $(this).attr('src', newSrc);
          $(this).attr('title', newTitle);
          $(this).velocity('fadeIn',{
            duration: self.settings.duration,
            easing: app.settings.easingOut
          });
        }
      });

    }
  }
};

app.modules.clients = new clients;

function socialShare() {}

socialShare.prototype = {

  vars: {
    listenerAdded: false
  },

  classes: {
    trigger: 'js-share'
  },

  config: {
    default: {
      popupWidth: 520,
      popupHeight: 350,
      urlKey: 'url'
    },
    facebook: {
      url: "https://www.facebook.com/sharer/sharer.php",
      urlKey: 'u'
    },
    twitter: {
      url: "https://twitter.com/intent/tweet/"
    },
    linkedin: {
      url: "https://www.linkedin.com/shareArticle"
    },
    pinterest: {
      url: "https://www.pinterest.com/pin/create/button/",
      popupHeight: "full",
      popupWidth: "half"
    },
    email: {
      overlay: 'ajax/share.html'
    }
  },

  parse: function($context){
    var $trigger = $context.find('.' + this.classes.trigger);
    if (!$trigger.length) {return;};
    this.addListener();
  },


  addListener: function(){

      // Dont add listener twice
      if (this.vars.listenerAdded) {return};

      jQuery('body')
      .on('click', '.' + this.classes.trigger, {self:this}, this.clickHandler);

      this.vars.listenerAdded = true;
    },


    clickHandler: function(event){

      event.preventDefault();

      var self = event.data.self;
      var $clicked = jQuery(this);
      var type = $clicked.data("type") || "facebook";
      var $window = jQuery(window);

      var config = jQuery.extend({}, self.config.default, self.config[type]);

      if (!config.url) {
        console.error('Sharing is not setup for "' + type + '"');
        return
      };

      var url = config.url;

      // Add parameter
      var parameter = [];
      parameter.push( config.urlKey + "=" + escape(window.location.href));
      parameter = "?" + parameter.join("&");
      url += parameter;

      // Convert "string" to height
      if (config.popupHeight == "full") {
        config.popupHeight = jQuery(window).height();
      };

      if (config.popupWidth == "half") {
        config.popupWidth = jQuery(window).width() / 2;

      };


      var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
      var windowTop = window.screenTop ? window.screenTop : window.screenY;


      var top = windowTop + ($window.height() / 2 - config.popupHeight / 2);
      var left = windowLeft + ($window.width() / 2 - config.popupWidth / 2);

      window.open(url, 'sharePopUp', 'height='+config.popupHeight + ', width='+ config.popupWidth + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }




  };

  app.modules.socialShare = new socialShare;

function team() {}

team.prototype = {

  elements:{
    team: undefined,
    item: undefined
  },

  classes:{
    team: '.js-team',
    item: '.js-team-item'
  },

  parse: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.team = $(this.classes.team);
    this.elements.item = $(this.classes.item);
  },

  addListener: function(){
    if(this.elements.team.length){
      this.elements.item.on('click', {self: this}, this.itemClickHandler);
    }
  },

  itemClickHandler: function(event){
    if(app.vars.isTouchDevice){
      var self = event.data.self;
      var element = $(this);
      var previousActive = element.siblings('.' + app.names.activeClass);
      previousActive.removeClass(app.names.activeClass);
      if(element.hasClass(app.names.activeClass)){
        element.removeClass(app.names.activeClass);
      } else{
        element.addClass(app.names.activeClass);
      }
    }
  }

};

app.modules.team = new team;

function news() {}

news.prototype = {

  settings:{
    limit: 3
  },

  elements:{
    news: undefined,
    loadMore: undefined,
    select: undefined
  },

  classes:{
    news: '.js-news',
    content: '.js-news-content',
    item: '.js-news-item',
    hiddenItem: '.js-news-item-hidden',
    loadMore: '.js-news-load-more',
    select: '.js-news-select',
    header: '.js-news-header'
  },

  names:{
    hiddenItem: 'js-news-item-hidden',
    filteredItem: 'js-news-item-filtered',
    notActive: 'not-active'
  },

  vars:{
  },

  init: function(){
  },

  parse: function(){
    this.defineElements();
    this.addListener();
    this.generateCategories();
  },

  defineElements: function(){
    this.elements.news = $(this.classes.news);
    this.elements.loadMore = $(this.classes.loadMore);
    this.elements.select = $(this.classes.select);
  },

  addListener: function(){
    this.elements.loadMore.on('click', {self: this}, this.loadMoreClickHandler);
    this.elements.select.on('change', {self: this}, this.selectChangeHandler);
  },

  loadMoreClickHandler: function(event){
    var self = event.data.self;
    var loadMore = $(this);
    var hiddenElements = loadMore.siblings(self.classes.hiddenItem);
    var targetContent = loadMore.closest(self.classes.content);
    if(hiddenElements.length <= self.settings.limit){
      self.hideLoadMore(loadMore);
    }

    setTimeout(function(){
      self.resizeSlideoutContainer(targetContent);
    }, 10);

    hiddenElements.each(function(index){
      if(index == self.settings.limit){
        return false;
      }
      $(this)
      .velocity('fadeIn',{
        duration: app.settings.duration,
        easing: app.settings.easing,
        display: 'block',
        complete: function(){
          $(this).removeClass(self.names.hiddenItem);
          self.resizeSlideoutContainer(targetContent);
        }
      });
  });
  },

  selectChangeHandler: function(event){
    var self = event.data.self;
    var selectValue = $(this).find(':selected').val();
    var tab = $(this).closest(self.classes.content);
    if(selectValue == 'all') {
      var items = tab.find(self.classes.item);
    } else {
      var items = tab.find(self.classes.item + '[data-news-category="' + selectValue + '"]');
    }
    self.showItems(items);
  },

  resizeSlideoutContainer: function(targetContent){
    var slideout = targetContent.closest(this.classes.news);
    var accordionState = app.modules.slideout.getAccordionSetting(slideout);
    app.modules.slideout.setContainerHeight(targetContent, slideout, accordionState);
  },

  hideLoadMore: function(loadMore){
    var self = this;
    var targetContent = loadMore.closest(self.classes.content);
    loadMore.velocity('slideUp',{
      duration: app.settings.duration/2,
      easing: app.settings.easing,
      complete: function(){
        self.resizeSlideoutContainer(targetContent);
      }
    });
  },

  showLoadMore: function(loadMore){
    var self = this;
    var targetContent = loadMore.closest(self.classes.content);
    loadMore.velocity('slideDown',{
      duration: app.settings.duration/2,
      easing: app.settings.easing,
      complete: function(){
        self.resizeSlideoutContainer(targetContent);
      }
    });
  },

  generateCategories: function(){
    var self = this;
    if(this.elements.news.length){
      var tabs = this.elements.news.find(this.classes.content);
      tabs.each(function(){
        self.findCategories($(this));
      });
    }
  },

  findCategories: function(tab){
    var items = tab.find(this.classes.item);
    var uniqueCategories = [];
    items.each(function(){
      var category = $(this).data('newsCategory');
      if(category != undefined && category != ''){
        if($.inArray(category, uniqueCategories) == '-1'){
          uniqueCategories.push(category);
        }
      }
    });

    this.addCategoriesToSelect(tab, uniqueCategories);
  },

  addCategoriesToSelect: function(tab, uniqueCategories){
    var select = tab.find(this.classes.select);
    if(uniqueCategories.length == 0) {
      var header = select.closest(this.classes.header);
      header.addClass(this.names.notActive);
    } else {
      $.each(uniqueCategories, function(key, value){
        var selectLine = $('<option value="' + value + '">' + value + '</option>');
        selectLine.appendTo(select);
      });
    }
  },

  showItems: function(items){
    var self = this;
    var tab = items.closest(this.classes.content);
    var otherItems = tab.find(this.classes.item).not(items);
    var loadMore = tab.find(this.classes.loadMore);
    var loadMoreStatus = false;

    otherItems.addClass(this.names.filteredItem).velocity('slideUp',{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });

    items.each(function(index){
      if(index < self.settings.limit) {
        $(this).velocity('fadeIn',{
          duration: app.settings.duration/2,
          easing: app.settings.easing,
          display: 'block',
          complete: function(){
            $(this).removeClass(self.names.hiddenItem).removeClass(self.names.filteredItem);
            self.resizeSlideoutContainer(tab);
          }
        });
      } else {
        loadMoreStatus = true;
        $(this).velocity('slideUp',{
          duration: app.settings.duration/2,
          easing: app.settings.easing,
          complete: function(){
            $(this).addClass(self.names.hiddenItem).removeClass(self.names.filteredItem);
          }
        });
      }
    });

    if(loadMoreStatus){
      self.showLoadMore(loadMore);
    } else {
      self.hideLoadMore(loadMore);
    }
  }

};

app.modules.news = new news;

function services() {}

services.prototype = {

  elements:{
    services: undefined,
    contents: undefined,
    blocks: undefined,
    block: undefined,
    spacer: undefined
  },

  classes:{
    services: '.js-services',
    blocks: '.js-services-blocks',
    block: '.js-services-block',
    blockContainer: '.js-services-block-container',
    contentContainer: '.js-services-content-container',
    contents: '.js-services-contents',
    content: '.js-services-content',
    spacer: '.js-services-spacer'
  },

  names:{
    contentContainer: 'js-services-content-container',
    blockActive: 'block-active'
  },

  vars:{
    currentService: '-1'
  },

  init: function(){
    this.addListener();
  },

  parse: function(){
    this.defineElements();
    this.loadInitialService();
  },

  defineElements: function(){
    this.elements.services = $(this.classes.services);
    this.elements.contents = $(this.classes.contents);
    this.elements.blocks = $(this.classes.blocks);
    this.elements.block = $(this.classes.block);
    this.elements.spacer = $(this.classes.spacer);
  },

  addListener: function(){
    $('body').on('click', this.classes.block, {self: this}, this.blockClickHandler);
  },

  blockClickHandler: function(event){
    var self = event.data.self;
    var block = $(event.currentTarget);
    var serviceName = block.data('service');
    if(self.vars.currentService == '-1'){
      self.vars.currentService = serviceName;
      self.showService(serviceName);
    } else {
      if(self.vars.currentService == serviceName){
        self.vars.currentService = '-1';
        self.hideService(serviceName);
      } else {
        self.vars.currentService = serviceName;
        self.showService(serviceName, true);
      }
    }
  },

  loadInitialService: function(){
    if(this.elements.services.length){
      var initialServiceData = this.elements.services.data('servicesActive');
      if(initialServiceData >= 0){
        console.log('load');
        this.showService(initialServiceData);
        this.vars.currentService = initialServiceData;
      }
    }
  },

  showService: function(serviceName, closeBeforeOpen, openingAfterClose){
    var block = this.findBlock(serviceName);
    var content = this.findContent(serviceName);
    var lastBlockInRow = this.getLastInRow(block);

    if(closeBeforeOpen){
      this.hideService(serviceName, true);
      return false;
    }

    this.markActiveBlock(block);
    this.generateContainer(lastBlockInRow);
    this.showContent(content);
    if(!closeBeforeOpen){
      this.hideSpacer();
    }
    // if(!openingAfterClose){
      this.scrollToItem(block);
    // }
  },

  hideService: function(serviceName, openAfterClose){
    if(openAfterClose){
      var previousElement = this.getCurrentActiveBlock();
      var nextElement = this.findBlock(serviceName);
      if(this.checkIfInSameLine(previousElement, nextElement)){
        this.clearContainer(serviceName, openAfterClose);
      } else {
        this.removeContainer(serviceName, openAfterClose);
      }
    } else {
      this.removeContainer();
      this.showSpacer();
      this.demarkActiveBlock();
    }
  },

  findBlock: function(serviceName){
    return this.elements.blocks.find(this.classes.block + '[data-service="' + serviceName + '"]');
  },

  getCurrentActiveBlock: function(){
    return this.elements.blocks.find(this.classes.block + '.' + this.names.blockActive);
  },

  findContent: function(serviceName){
    return this.elements.contents.find(this.classes.content + '[data-service="' + serviceName + '"]');
  },

  getLastInRow: function(element){
    var nextElement = element.next();
    if(nextElement.length){
      if(element.offset().top == nextElement.offset().top){
        return this.getLastInRow(nextElement);
      } else {
        return element;
      }
    } else {
      return element;
    }
  },

  generateContainer: function(lastBlockInRow){
    var blocksAfter = lastBlockInRow.nextAll();
    var currentContainer = lastBlockInRow.closest(this.classes.blockContainer);
    blocksAfter.detach();
    currentContainer.clone(true).appendTo(this.elements.blocks).empty().append(blocksAfter);
    var contentContainer = $('<div>').addClass(this.names.contentContainer);
    currentContainer.after(contentContainer);
  },

  removeContainer: function(serviceName, openAfterClose){
    var self = this;
    var contentContainer = this.elements.blocks.find(this.classes.contentContainer);

    contentContainer.velocity('slideUp',{
      duration: app.settings.duration/2,
      easing: app.settings.easingOut,
      complete: function(){
        var firstBlockContainer = self.elements.blocks.find(self.classes.blockContainer).eq(0);
        var secondBlockContainer = self.elements.blocks.find(self.classes.blockContainer).eq(1);
        firstBlockContainer.append(secondBlockContainer.html());
        contentContainer.remove();
        secondBlockContainer.remove();
        if(openAfterClose){
          self.showService(serviceName, false, true);
        }
      }
    });
  },

  clearContainer: function(serviceName, openAfterClose){
    var self = this;
    var contentContainer = this.elements.blocks.find(this.classes.contentContainer);
    contentContainer.empty();
    if(openAfterClose) this.appendContentToContainer(serviceName);
  },

  showContent: function(content){
    var self = this;
    var contentContainer = this.elements.blocks.find(this.classes.contentContainer);
    contentContainer
    .css('display', 'none')
    .append(content.clone(true))
    .velocity('slideDown',{
      duration: app.settings.duration/2,
      easing: app.settings.easingIn,
      complete: function(){
        self.setTabHeight();
      }
    });
  },

  appendContentToContainer: function(serviceName){
    var contentContainer = this.elements.blocks.find(this.classes.contentContainer);
    var block = this.findBlock(serviceName);
    var content = this.findContent(serviceName);
    contentContainer.append(content.clone(true));
    this.markActiveBlock(block);
    this.setTabHeight();
  },

  markActiveBlock: function(block){
    var previousActive = this.getCurrentActiveBlock();
    previousActive.removeClass(this.names.blockActive);
    block.addClass(this.names.blockActive);
  },

  demarkActiveBlock: function(){
    var previousActive = this.getCurrentActiveBlock();
    previousActive.removeClass(this.names.blockActive);
  },

  scrollToItem: function(block){
    block.velocity('scroll',{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });
  },

  setTabHeight: function(){
    var slideout = this.elements.services.find('.' + app.modules.slideout.classes.slideout);
    app.modules.slideout.setCurrentTabHeight(slideout);
  },

  hideSpacer: function(){
    this.elements.spacer.velocity('slideUp',{
      duration: app.settings.duration/2,
      easing: app.settings.easingOut
    });
  },

  showSpacer: function(){
    this.elements.spacer.velocity('slideDown',{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });
  },

  checkIfInSameLine: function(previousElement, nextElement){
    if(previousElement.offset().top == nextElement.offset().top){
      return true;
    } else {
      return false;
    }
  }



};

app.modules.services = new services;

function overlay() {}

overlay.prototype = {

  settings:{
    animationDistance: '50'
  },

  elements:{
    overlay: undefined,
    overlayContainer: undefined,
    overlayBox: undefined,
    overlayArticle: undefined,
    canvas: undefined,
    link: undefined,
    close: undefined,
    ajaxBackground: undefined,
    overlayBg: undefined
  },

  classes:{
    link: '.js-overlay-link',
    close: '.js-overlay-close'
  },

  ids:{
    overlay: '#overlay',
    overlayContainer: '#overlay-container',
    overlayBox: '#overlay-box',
    overlayArticle: '#overlay-article',
    canvas: '#canvas',
    ajaxBackground: '#overlay-ajax-background',
    overlayButtons: '#overlay-buttons',
    overlayBg: '#overlay-bg'
  },

  names:{
    isFixed: 'is-fixed',
    staticClass: 'overlay--static',
    linkTarget: '_top'
  },

  vars:{
    canvasOriginalPosition: 0,
    overlayOpen: false,
    originalPageUrl: '',
    originalPageTitle: '',
    basePageUrl: ''
  },

  init: function(){
    this.defineElements();
    this.launchStaticOverlay();
    this.addListener();
  },

  parse: function(){
    this.defineElements();
  },

  defineElements: function(){
    this.elements.overlay = $(this.ids.overlay);
    this.elements.overlayContainer = $(this.ids.overlayContainer);
    this.elements.overlayBox = $(this.ids.overlayBox);
    this.elements.overlayArticle = $(this.ids.overlayArticle);
    this.elements.canvas = $(this.ids.canvas);
    this.elements.link = $(this.classes.link);
    this.elements.close = $(this.classes.close);
    this.elements.ajaxBackground = $(this.ids.ajaxBackground);
    this.elements.overlayBg = $(this.ids.overlayBg);
  },

  addListener: function(){

    $('body').on('click', this.classes.link, {self: this}, this.linkClickHandler);
    $('body').on('click', 'a[target="' + this.names.linkTarget + '"]', {self: this}, this.linkClickHandler);

    this.elements.close.on('click', {self: this}, this.closeClickHandler);

    $(window).on('statechange', {self: this}, this.stateChangeHandler);

    $(document).on('click', {self: this}, function(event) {
      var self = event.data.self;
      if (!$(event.target).closest(self.ids.overlayBox).length && self.vars.overlayOpen) {
        self.closeClickHandler(event);
      }
    });
  },

  linkClickHandler: function(event){
    event.preventDefault();
    var self = event.data.self;
    var link = $(this);
    var url = link.attr('href');
    var title = link.attr('alt');

    if(self.vars.basePageUrl == ''){
      var currentUrl = window.location.href;
      var basecurrentUrl = currentUrl.split('?');
      self.vars.basePageUrl = basecurrentUrl[0];
      basecurrentUrl = basecurrentUrl[0];
    } else {
      basecurrentUrl = self.vars.basePageUrl;
    }

    self.vars.originalPageUrl = basecurrentUrl;
    self.vars.originalPageTitle = document.title;
    History.pushState({state:'overlay'}, title, url);
  },

  closeClickHandler: function(event){

    if(!$(event.target).hasClass('js-cookie-info-button')){
      var self = event.data.self;
      History.pushState({state:'normalPage'}, self.vars.originalPageTitle, self.vars.originalPageUrl);
    }

  },

  stateChangeHandler: function(event){
    var self = event.data.self;
    var currentState = History.getState();
    var url = currentState['url'];
    if(currentState.data.state == 'overlay'){
      self.openOverlay(url);
    } else if (currentState.data.state == 'normalPage'){
      if(self.vars.overlayOpen){
        self.closeOverlay(url);
      }
    }
  },

  openOverlay: function(url){
    var self = this;
    this.fixCanvas();
    this.setOverlayHeight();
    this.animateInOverlay();
    this.loadPage(url);
  },

  closeOverlay: function(){
    var self = this;
    this.animateOutOverlay();
    this.removeStaticClass();
  },

  fixCanvas: function(){
    var canvas = this.elements.canvas;
    var canvasOffset = $('html').scrollTop();
    if(canvasOffset == 0) {
      canvasOffset = $('body').scrollTop();
    }

    canvas
    .addClass(this.names.isFixed)
    .css('top', -canvasOffset);

    this.vars.canvasOriginalPosition = canvasOffset;
  },

  unfixCanvas: function(){
    var canvas = this.elements.canvas;
    canvas.removeClass(this.names.isFixed);
    $('body, html').scrollTop(this.vars.canvasOriginalPosition);
  },

  setOverlayHeight: function(){
    this.elements.overlayContainer.css('min-height', $(window).outerHeight());
    this.elements.overlayBox.css('min-height', $(window).outerHeight());
  },

  animateInOverlay: function(){
    var self = this;
    this.elements.overlay
    .velocity('fadeIn',{
      duration: app.settings.duration/2,
      easing: app.settings.easing,
      display: 'block',
      complete: function(){
        self.vars.overlayOpen = true;
      }
    });

    this.elements.overlayBox
    .css('margin-top', -self.settings.animationDistance)
    .velocity({
      'margin-top': 0
    },{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });
  },

  animateOutOverlay: function(){
    var self = this;
    this.elements.overlay
    .velocity('fadeOut',{
      duration: app.settings.duration/2,
      easing: app.settings.easing,
      complete: function(){
        self.animateOutOverlayFinished($(this));
      }
    });

    this.elements.overlayBox
    .velocity({
      'margin-top': -self.settings.animationDistance
    },{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });

    this.animateOutOverlayArticle();

  },

  animateOutOverlayFinished: function(overlay){
    this.unfixCanvas();
    this.elements.overlayArticle.empty();
    this.vars.overlayOpen = false;
    overlay.css('top', 0);
  },

  animateInOverlayArticle: function(){
    var self = this;
    this.elements.overlayArticle
    .velocity({
      'opacity': 1
    },{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });
  },

  animateOutOverlayArticle: function(){
    var self = this;
    this.elements.overlayArticle
    .velocity({
      'opacity': 0
    },{
      duration: app.settings.duration/2,
      easing: app.settings.easing
    });
  },

  removeStaticClass: function(){
    this.elements.overlay.removeClass(this.names.staticClass);
  },

  loadPage: function(url){
    var self = this;
    var container = this.elements.overlayArticle;
    app.modules.preloader.showPreloader(container, 999);

    var overlayPageCall = $.ajax({
      url: url,
      method: 'POST',
      data: {'ajaxCall': true}
    })
    .done(function(msg) {
      self.pageLoaded(msg, container);
    })
    .fail(function() {
    })
    .always(function() {
    });
  },

  pageLoaded: function(msg, container){
    container.append(msg);

    if($(container).find('.js-form-order').length > 0){
      $(container).parents('.overlay__container').addClass('overlay__container--order');
    }

    app.modules.preloader.hidePreloader(container, 999);
    this.animateInOverlayArticle();
    this.loadScripts();
  },

  launchStaticOverlay: function(){
    if(this.elements.ajaxBackground.length){
      var self = this;
      var ajaxBackground = this.elements.ajaxBackground;
      var page = ajaxBackground.data('page');
      this.vars.overlayOpen = true;
      this.vars.originalPageUrl = page;
      this.vars.originalPageTitle = ajaxBackground.data('title');

      ajaxBackground.css('opacity', 0);
      this.setOverlayHeight();

      app.modules.preloader.showPreloader(ajaxBackground, 998);
      var ajaxBgCall = $.ajax({
        url: page,
        method: 'POST',
        data: {'ajaxCallBg': true}
      })
      .done(function(msg) {
        self.staticOverlayLoaded(msg, ajaxBackground);
      });
    }
  },

  staticOverlayLoaded: function(msg, ajaxBackground){
    ajaxBackground.append(msg);
    app.modules.preloader.hidePreloader(ajaxBackground, 998);
    app.parse(ajaxBackground);
    app.modules.initPlugins.initStickyKit(this.ids.overlayButtons);
    var canvas = $(this.ids.canvas);
    canvas.addClass(this.names.isFixed);
    ajaxBackground.velocity({
      'opacity': 1
    },{
      duration: app.settings.duration,
      easing: app.settings.easing
    });
  },

  loadScripts: function(){
    app.modules.initPlugins.initStickyKit(this.ids.overlayButtons);
    app.modules.validateForm.init();
  }

};

app.modules.overlay = new overlay;

function scrollToElement() {}

scrollToElement.prototype = {

  elements:{
    btn: undefined
  },

  classes:{
    btn: '.js-scroll-to-btn'
  },

  parse: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.btn = $(this.classes.btn);
  },

  addListener: function(){
    this.elements.btn.on('click', {self: this}, this.btnClickHandler);
  },

  btnClickHandler: function(event){
    event.preventDefault();
    var self = event.data.self;
    var element = $(this);
    var target = $(element.data('scrollTarget'));

    target.velocity("scroll", {
      duration: app.settings.duration*2,
      easing: app.settings.easingInOut
    });
  }
};

app.modules.scrollToElement = new scrollToElement;

function fileButtonCheck() {}

fileButtonCheck.prototype = {

  elements:{
    fileBtn: undefined,
  },

  classes:{
    fileBtn: '.js-file-btn',
    fieldName: '.js-field-name',
    fileName: '.js-file-name',
    submitBtn: '.js-submit-btn',
    isActive: 'is-active',
    isWrong: 'is-wrong',
    isTop: 'is-top'
  },

  ids:{
    submitBtn: '#submit-career-form'
  },

  vars:{
    fileValidated: false
  },

  init: function(){
    this.defineElements();
    this.addListener();
  },

  defineElements: function(){
    this.elements.submitBtn = $(this.classes.submitBtn);
  },

  addListener: function(){
    $('body').on('change', this.classes.fileBtn, {self: this}, function(e){
      var self = e.data.self;
      var element = $(this);
      self.markButton(element);
    });
  },

  markButton: function(element){
    var file = element[0].value;
    var extension = file.substr( (file.lastIndexOf('.') +1) );
    var fileLastName = file.substr( (file.lastIndexOf('\\') +1) );
    var label = element.closest('label');
    if(extension == 'pdf'){
      label.removeClass(this.classes.isWrong);
      label.addClass(this.classes.isActive);
      this.showFileName(label, fileLastName);
      this.vars.fileValidated = true;
    } else {
      label.removeClass(this.classes.isActive);
      label.addClass(this.classes.isWrong);
      this.vars.fileValidated = false;
    }
  },

  showFileName: function(element, file){

    var fieldName = element.find(this.classes.fieldName);
    var fileName = element.find(this.classes.fileName);
    fieldName.addClass(this.classes.isTop);
    fileName.html(file);
  },

  clearButton: function(){
    var element = this.elements.fileBtn;
    var label = element.closest('label');

    label.removeClass(this.classes.isActive);
    label.removeClass(this.classes.isWrong);
    this.vars.fileValidated = false;
  }

};

app.modules.fileButtonCheck = new fileButtonCheck;

function validateForm() {}

validateForm.prototype = {

  elements: {
    form: undefined,
    message: undefined
  },

  classes: {
    form: '.js-form',
    message: '.js-form-success-message',
    button: '.js-form-submit'
  },

  vars: {
    happy: undefined
  },

  init: function(){
    this.defineElements();
    this.formValidation();
    this.showSuccessMsg();

    $('.js-tnb_label, .js-privacy_label').on('click',function(e){

      if($(e.target).prop('tagName').toLowerCase() !== 'a'){

        e.preventDefault();

        var $inp = $(this).parents('.form__row--radio').find('input[type=radio]');

        if(!$inp.prop("checked")){
          $inp.prop("checked", true);
        } else {
          $inp.prop("checked", false);
          $inp.removeAttr('checked');
        }

      }

    });
  },

  defineElements: function(){
    this.elements.form = $(this.classes.form);
    this.elements.message = $(this.classes.message);
  },

  formValidation: function(){
    var self = this;

    jQuery.extend(jQuery.validator.messages, {
      required: $('#form-required-msg').text(),
    });

    $('.js-form-order .js-form-submit').on('click', function(){

        $('.type_error').hide(0);
        var $type_wrap = $('#order_types').next();

        if($('.js-form-order').length > 0 && $type_wrap.find('input[value=1]:checked').length < 1){
          $('.type_error').show(0);
        }
    });

    this.elements.form.validate({
      rules: {
        email: {
          required: true,
          email: true
        },
        email_re: {
          required: true,
          email: true
        },
        email_auf: {
          required: true,
          email: true
        },
        tnb: {
          required: true
        },
        privacy: {
          required: true
        }
      },
      submitHandler: function(form){

        var submit = true;
        $('.type_error').hide(0);

        var $type_wrap = $('#order_types').next();

        if($('.js-form-order').length > 0 && $type_wrap.find('input[value=1]:checked').length < 1){
          window.scrollTo(0, $('#order_types').offset().top);
          $('.type_error').show(0);
          submit = false;
        }

        if(submit){
          if($('#bookingnr').length > 0){
            var ts = new Date().getTime() / 1000;
          } $('#bookingnr').val(Math.ceil(ts));

          form.submit();
          self.addLoaderToButton(form);
        }

      }
    });
  },

  showSuccessMsg: function(){
    if(this.elements.message.length){
      var formMsg = this.elements.message.html();

      if($('.js-form-order').length > 0){

        var $form = $('.js-form-order');
        var success_headline = $form.data('successheadline');
        var success_text = $form.data('successtext');

        formMsg = '<strong>' + success_headline + '</strong><br>' + success_text;
      }

      app.modules.popup.createPopup(formMsg, 'primary');
    }
  },

  addLoaderToButton: function(form){
    var button = $(this.classes.button);
    app.modules.preloader.showPreloader(button, 333, 'instead');
  }

};

app.modules.validateForm = new validateForm;



// popup.js
// Notifications for your page
// 04.2015 by Szczepan Król
// LOOP Agentur

// Use:
// app.modules.popup.createPopup(message, style); - 'style' currently supports: 'primary', 'light', 'success'

// Dependencies
// velocity.js

function popup() {}

popup.prototype = {

  elements: {
    popup: $('#popup')
  },

  settings: {
    messageTime: 5 // seconds
  },

  classes: {
    popup: 'popup',
    colorPrimary: 'popup--primary',
    colorLight: 'popup--light',
    colorSuccess: 'popup--success'
  },

  vars: {
    popupHeight: '',
    timeout: ''
  },
 
  createPopup: function(message, color){
    var popup = $('<div>')
                .addClass(this.classes.popup)
                .attr('id', this.classes.popup)
                .append(message);
    
    if(color == 'primary'){
      popup.addClass(this.classes.colorPrimary);  
    } else if (color == 'light'){
      popup.addClass(this.classes.colorLight);  
    } else if (color == 'success'){
      popup.addClass(this.classes.colorSuccess);  
    }
    $('body').prepend(popup, this.positionPopup(popup));
  },

  positionPopup: function(popup){
    var self = this;
    setTimeout(function(){
      self.vars.popupHeight = popup.outerHeight();
      popup.css('top', -self.vars.popupHeight);
      self.showMessage(popup);
    }, 100);
  },

  showMessage: function(popup){
    var self = this;

    clearTimeout(this.vars.timeout);
    popup.show().velocity(
    {
      top: '30px' 
    },
    {
      easing: app.settings.easing,
      duration: app.settings.duration/3
    });

    this.vars.timeout = setTimeout(function(){
      self.hideMessage(popup);
    }, self.settings.messageTime * 1000);
  },

  hideMessage: function(popup){
    var self = this;
    clearTimeout(this.vars.timeout);
    popup.velocity(
    {
      top: -this.vars.popupHeight
    },
    {
      easing: app.settings.easing,
      duration: app.settings.duration/3,
      complete: function(){
        popup.remove();
      }
    });
  }


};


app.modules.popup = new popup;



function onScreen() {}

onScreen.prototype = {

  elements:{

  },

  classes:{

  },

  names:{

  },

  parse: function(){
    this.initOnScreen();
  },

  defineElements: function(){

  },

  initOnScreen: function(){
    $('.js-onscreen').onScreen({
       tolerance: 0,
       throttle: 50,
       visible: function(){
          $(this).addClass('is-onscreen');
       }
     });
  }

};

app.modules.onScreen = new onScreen;


function heroLoaded() {}

heroLoaded.prototype = {

  elements:{
    hero: undefined
  },

  ids:{
    hero: '#hero'
  },

  names:{
    heroLoaded: 'hero-loaded',
    heroBg: 'js-hero-bg'
  },

  init: function(){
    this.defineElements();
    this.showPreloader();
    this.addListener();
  },

  defineElements: function(){
    this.elements.hero = $(this.ids.hero);
  },

  addListener: function(){
    if(this.elements.hero.length){
      $(document).on('responsiveImgLoaded', {self: this}, function(event, element){
        var self = event.data.self;
        if($(element).hasClass(self.names.heroBg)){
         $('body').addClass(self.names.heroLoaded);
         app.modules.preloader.hidePreloader(self.elements.hero, 995);
       }
     });
    }
  },

  showPreloader: function(){
    if(this.elements.hero.length){
      app.modules.preloader.showPreloader(this.elements.hero, 995);
    }
  }


};

app.modules.heroLoaded = new heroLoaded;

function founders() {}

founders.prototype = {

  elements: {
  },

  settings: {
  },

  classes: {
    founders: '.js-founders',
    button: '.js-founders-button',
  },

  vars: {
    currentActiveButton: 1,
    buttonWidth: undefined,
    positioningInitiated: false,
  },

  parse: function(){
    if( $(this.classes.founders).length ){
      if(!app.vars.smallScreenState){
        this.initialSetup();
        this.addListeners();
        this.vars.positioningInitiated = true;
      }
    }
  },

  stateChange: function(){
    if( $(this.classes.founders).length ){
      if(app.vars.smallScreenState){
        this.removeButtonPositioning();
      } else {
        if( !this.vars.positioningInitiated ){
          this.initialSetup();
          this.addListeners();
          this.vars.positioningInitiated = true;
        }
      }
    }
  },

  addListeners: function(){
    $('body').on('click', this.classes.button, {self: this}, this.buttonClickHandler);
  },

  buttonClickHandler: function(event){
    var self = event.data.self;
    var buttonId = $(this).data('slideout');
    self.positionButton(buttonId);

  },

  initialSetup: function(){
    var self = this;
    var $buttons = $(this.classes.button);
    var buttonCount = $buttons.length;
    this.vars.buttonWidth = 100/buttonCount;

    $founders = $(this.classes.founders);
    $founders.css('height', $($buttons[0]).outerHeight());

    $buttons.each(function(index){
      $(this).css({
        position: 'absolute',
        top: 0,
        left: (index*self.vars.buttonWidth) + '%'
      });
    });
  },

  positionButton: function(buttonId){
    var self = this;
    var $previousButton = $(this.classes.button + '[data-slideout="'+ this.vars.currentActiveButton +'"]');
    var $currentButton = $(this.classes.button + '[data-slideout="'+ buttonId +'"]');

    $previousButton.css({
      left: $currentButton[0].style.left
    });

    $currentButton.css({
      left: 0
    });

    this.vars.currentActiveButton = buttonId;
  },

  removeButtonPositioning: function(){
    var $buttons = $(this.classes.button);
    $buttons.each(function(index){
      $(this).removeAttr('style');
    });

    $(this.classes.founders).removeAttr('style');
  }


};


app.modules.founders = new founders;



function ceb_popup() {}

ceb_popup.prototype = {

  settings: {
    path: 'request-customer-experience-benchmark-report',
    fallback: 'en',
    closed: localStorage.closedSettings === 'yes',
    closed: false
  },

  classes: {
    el: '.js-ceb_popup',
    content: '.ceb_p__content',
    center: '.ceb_p__center',
    close: '.ceb_p__close',
    success: '.ceb_p__success',
  },

  els: {

  },

  setupEls: function() {
    this.els = {
      window: $(window),
      body: $('body'),
      el: $(this.classes.el),
      content: $(this.classes.el).find(this.classes.content),
      center: $(this.classes.el).find(this.classes.center),
      close: $(this.classes.el).find(this.classes.close),
      success: $(this.classes.el).find(this.classes.success),
    }
  },

  open: function() {
    if (this.settings.closed)
      return;
    var cls = this;
    var sct = (window.pageYOffset || document.documentElement.scrollTop);
    this.settings.sct = sct;

    var times = 100;
    var i = 0;
    // var scint = function() {
    //   i++;

    //   if (i < times) {
    //     cls.settings.sctt = setTimeout(scint);
    //   };
    // }
    // scint();

    this.els.body.css({
      marginTop: sct * -1,
      // height: window.innerHeight + sct,
      // overflow: 'hidden'
      position: 'fixed',
      width: '100%'
    });

    window.scrollTo(0, 0);


    cls.els.el.addClass('visible');
  },

  close: function() {
    var cls = this;
    var sct = this.settings.sct;
    clearTimeout(this.settings.sctt);
    this.settings.closed = true;
    localStorage.closedSettings = 'yes';

    this.els.el.removeClass('visible');

    setTimeout(function() {
      cls.els.body.removeAttr('style');
      // cls.els.body.css({
      //   marginTop: 0,
      //   height: 'auto',
      //   overflow: 'inherit',
      //   position: 'relative',

      // });

      window.scrollTo(0, sct);
    })
  },

  sendReq: function() {
    var zerofy = function(int) {
      if (int < 10)
        int = '0' + int;

      return int;
    }
    var cls = this;
    var time = new Date();
    var data = {
      activeID: this.settings.activeID,
      fallbackID: this.settings.fallbackID,
      name: this.els.form.find('[name="name"]').val(),
      lastname: this.els.form.find('[name="lastname"]').val(),
      company: this.els.form.find('[name="company"]').val(),
      email: this.els.form.find('[name="email"]').val(),
      lang: this.getLang(),
      time: time.getFullYear() + '-' + zerofy(time.getMonth() + 1) + '-' + zerofy(time.getDate()) + ' ' + zerofy(time.getHours()) + ':' + zerofy(time.getMinutes()) + ':' + zerofy(time.getSeconds())
    };


    $.ajax({
      url: '/sys/post/12864',
      type: 'POST',
      data: data,
      success: function(res) {
        var json = JSON.parse(res);
        if (json.success) {
          cls.els.el.addClass('success');
          localStorage.closedSettings = 'yes';
        }
      }
    });
  },

  validateForm: function() {
    var cls = this;

    var $form = cls.els.form;
    $form.on('submit', function() {
      $form.validate({
        rules: {
          email: {
            required: true,
            email: true
          },
          name: {required: true},
          last_name: {required: true},
        },
        submitHandler: function(form) {
          cls.sendReq();
        }
      });
      return false;
    }).trigger('submit');
  },

  getCfromFallback: function($act, $fb) {
    $act.find('label').each(function() {
      if ($(this).text().trim().length < 1) {
        $(this).text( $fb.find('label[for="'+$(this).attr('for')+'"]').text().trim() );
      }
    });
    $act.find('input[type="submit"]').each(function() {
      if ($(this).val().length < 1) {
        $(this).val( $fb.find('input[type="submit"]').val() );
      }
    });
    $act.find('.success_text').each(function() {
      if ($(this).text().trim().length < 1) {
        $(this).text( $fb.find('.success_text').text().trim() );
        $('.ceb_p__success').text( $fb.find('.success_text').text().trim() );
      }
    });
    if ($act.find('#f-title').text().trim().length < 1) {
      $act.find('#f-title').html( $fb.find('#f-title').html() );
    }
  },

  loadContent: function(set) {
    var cls = this;
    var lang = set || this.getLang();
    this.settings.lang = lang;

    $.get('/' + this.settings.lang + '/' + this.settings.path, function(res) {
      var $res = $(res);

      cls.settings.activeID = $res.find('form').attr('page_id');

      cls.els.success.html('<div>'+$res.find('.success_text').text().trim()+'</div>');

      cls.els.content.append($res);
      cls.els.form = $res.find('form');
      cls.validateForm();

      var $labels = $res.find('label');
      var allFilled = true;
      $labels.each(function() {
        if ($(this).text().trim().length === 0) {
          allFilled = false;
        }
      });

      // if (!allFilled) {
      //   // TODO: load english as fallback
      // }

      $.get('/en/' + cls.settings.path, function(enres) {
        var $enres = $(enres);
        cls.getCfromFallback($res, $enres);
        cls.settings.fallbackID = $enres.find('form').attr('page_id');
      });
    });
  },

  getLang: function() {
    var lang = window.location.href.split('/');
    lang = lang[3];
    if (!lang || lang.length !== 2)
      lang = this.settings.fallback;

    return lang;
  },

  init: function() {
    var cls = this;
    this.setupEls();

    if (this.els.el.length) {

      this.loadContent();

      this.els.close.on('click', function() {
        cls.close();
      });


      var doc = $(document);

      cls.els.window.on('scroll', function() {
        var offtop = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight;
        if (doc.height() - offtop < 600) {
          cls.open();
        }
      });
    }

    // test
    // $('html, body').animate({
    //   scrollTop: 99999999
    // }, 100);
    // setTimeout(function() {
    //   cls.open();
    // }, 200);
  },


};

app.modules.ceb_popup = new ceb_popup;


function cookieInfo() {}

cookieInfo.prototype = {

  classes: {
    cookieInfo: '.js-cookie-info',
    button: '.js-cookie-info-button',
  },

  parse: function(){
    if( $(this.classes.cookieInfo).length ){
      this.addListeners();
    }
  },

  addListeners: function(){
    $('body').on('click', this.classes.button, {self: this}, this.buttonClickHandler);
  },

  buttonClickHandler: function(event){
    var self = event.data.self;
    event.preventDefault();
    self.acceptCookies();
  },

  acceptCookies: function(buttonId){
    var self = this;
    Cookies.set('iscCookiesAccepted', '1', {expires: 1000, path: ''});
    $(this.classes.cookieInfo).remove();
  },

};


app.modules.cookieInfo = new cookieInfo;





